import { TASK_PRIORITY_LABELS, type TaskPriority } from "@quovy/types";

export const PRIORITY_LABELS: Record<TaskPriority, string> = TASK_PRIORITY_LABELS;

export const PRIORITY_CLASSES: Record<TaskPriority, string> = {
  low: "border-zinc-300 bg-zinc-100 text-zinc-600",
  medium: "border-amber-300 bg-amber-50 text-amber-700",
  high: "border-orange-300 bg-orange-50 text-orange-700",
  urgent: "border-rose-300 bg-rose-50 text-rose-700",
};

export function formatTaskPriorityLabel(priority: TaskPriority) {
  return PRIORITY_LABELS[priority];
}
